var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from "react";
/**
 * Get an array of [value, setValue] boolean state entries.
 * Only one value can be true at a time.  Setting one to true will
 * set all others to false.
 *
 * @param count The number of boolean states to generate.
 */
export function useExclusiveBooleanStates(count, defaultFirstOpen) {
    if (defaultFirstOpen === void 0) { defaultFirstOpen = false; }
    var initialState = Array.from({ length: count }).map(function (_, i) { return i === 0 && defaultFirstOpen; });
    var _a = __read(React.useState(initialState), 2), states = _a[0], setStates = _a[1];
    // We do not need to update the functions in here when outside state changes,
    //  as they set our states to values only determined by the arguments to setOpen
    var entries = React.useMemo(function () {
        return Array.from({ length: count }).map(function (_, index) {
            var _a;
            return [
                (_a = states[index]) !== null && _a !== void 0 ? _a : false,
                function (state) {
                    // Turn off all accordion states, except our own if we are being turned on.
                    setStates(Array.from({ length: count }).map(function (_, setIndex) { return index === setIndex && state; }));
                }
            ];
        });
    }, __spreadArray([], __read(states), false));
    return entries;
}
//# sourceMappingURL=useExclusiveBooleanStates.js.map